import Directory from "../../components/directory/directory";

const Home = () => {
  return <Directory />;
};

export default Home;
